import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { FormsModule } from '@angular/forms';
import { TuiAvatar } from '@taiga-ui/kit';
import { TuiDataList, TuiInitialsPipe, TuiAutoColorPipe } from '@taiga-ui/core';
import { SharedModule } from '@src/app/shared';
import { ComponentsModule } from '@src/app/components';
import { IconModule } from '@src/app/modules/icon';

import { BotComponent } from './bot.component';

@NgModule({
  declarations: [BotComponent],
  imports: [
    CommonModule,
    RouterModule,
    SharedModule,
    TuiAvatar,
    ...TuiDataList,
    ComponentsModule,
    IconModule,
    FormsModule,
    TuiInitialsPipe,
    TuiAutoColorPipe,
  ],
  exports: [BotComponent],
})
export class BotModule {}
